import { ApiService, type Progress } from './api.service'

export class ProgressService extends ApiService {
  /**
   * Get user's progress for all modules
   */
  async getUserProgress(userId: string): Promise<Progress[]> {
    return this.handleResponse(this.api.get<Progress[]>(`/progress/user/${userId}`))
  }

  /**
   * Get current user's own progress for all modules
   */
  async getMyProgress(): Promise<Progress[]> {
    return this.handleResponse(this.api.get<Progress[]>('/progress/my-progress'))
  }

  /**
   * Get all users' progress for a module (Admin only)
   */
  async getModuleProgress(moduleId: string): Promise<Progress[]> {
    return this.handleResponse(this.api.get<Progress[]>(`/progress/module/${moduleId}`))
  }

  /**
   * Get specific user progress for a module
   */
  async getUserModuleProgress(userId: string, moduleId: string): Promise<Progress> {
    return this.handleResponse(
      this.api.get<Progress>(`/progress/user/${userId}/module/${moduleId}`)
    )
  }

  /**
   * Get current user's progress for a specific module
   */
  async getMyModuleProgress(moduleId: string): Promise<Progress> {
    return this.handleResponse(this.api.get<Progress>(`/progress/my-progress/${moduleId}`))
  }

  /**
   * Mark video as watched
   */
  async markVideoComplete(moduleId: string): Promise<Progress> {
    return this.handleResponse(this.api.patch<Progress>(`/progress/${moduleId}/video-complete`))
  }

  /**
   * Submit quiz answers
   */
  async submitQuiz(quizData: {
    moduleId: string
    userId: string
    language: string
    answers: number[]
    timeTaken: number
  }): Promise<{
    passed: boolean
    correctAnswers: number
    totalQuestions: number
    message: string
    attemptId: string
  }> {
    return this.handleResponse(
      this.api.post(`/progress/${quizData.moduleId}/submit-quiz?language=${quizData.language}`, {
        answers: quizData.answers,
      })
    )
  }

  /**
   * Reset quiz for retake
   */
  async retakeQuiz(moduleId: string): Promise<void> {
    return this.handleResponse(this.api.post<void>(`/progress/${moduleId}/retake-quiz`))
  }

  /**
   * Get user's quiz attempt history (Admin only)
   */
  async getUserQuizHistory(userId: string): Promise<any[]> {
    return this.handleResponse(this.api.get<any[]>(`/progress/user/${userId}/history`))
  }
}

// Export singleton instance
export const progressService = new ProgressService()
